export function XLogoOutlined({ className }: { className?: string }) {
    return (
        <svg
            width="63"
            height="62"
            viewBox="0 0 63 62"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="1.66699"
                y="1"
                width="60"
                height="60"
                rx="30"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M34.425 28.7029L45.2203 16H42.6617L33.2907 27.0293L25.8024 16H17.167L28.489 32.68L17.167 46H19.7256L29.6233 34.3514L37.5316 46H46.167L34.425 28.7029ZM30.9218 32.8257L29.7747 31.165L20.6467 17.95H24.5764L31.941 28.615L33.0881 30.2757L42.6638 44.14H38.7342L30.9218 32.8257Z"
                fill="currentColor"
            />
        </svg>
    )
}
